<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title">Consumo Marca Genérico</span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="!isLoading || productSubtypeData" class="indicator-total">Total: {{ getProductSubTypeTotal() }}</div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading || productSubtypeData" class="indicator-content-container">
    <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'bar'"></canvas>
  </div>
</div>
